<template>
  <a-form-field
    v-bind="formFieldAttrs"
    :max-length="maxLength"
    :value-length="valueLength"
  >

    <textarea
      ref="input"
      slot-scope="slotProps"
      :aria-describedby="slotProps.describedby"
      :aria-invalid="hasError ? 'true' : 'false'"
      :id="id"
      :value="value"
      v-bind="$attrs"
      class="form-input form-input--textarea"
      v-on="listeners"
    />

  </a-form-field>
</template>

<script>
import AFormField from '@/components/form/atoms/AFormField'
import BFormInput from '@/components/form/base/BFormInput'

export default {
  name: 'CFormTextarea',

  components: {
    AFormField
  },

  extends: BFormInput,

  props: {
    value: {
      type: [Number, String]
    },
    maxLength: {
      type: Number,
      default: 0
    }
  },
  computed: {
    valueLength () {
      if (this.value) {
        return this.value.length
      }

      return 0
    }
  }
}
</script>
